import styled from 'styled-components';

export const ImageAvatar = styled.img<{ size?: 'small' | 'medium' }>`
  height: ${(props) => (props.size === 'small' ? 40 : 50)}px;
  width: ${(props) => (props.size === 'small' ? 40 : 50)}px;
  border-radius: 50%;
  object-fit: cover;
`;
